import * as React from "react";

import { Box } from "@material-ui/core";

import { MopButton } from "client/components";
import { useTranslation } from "client/hooks";

export const SubmitButtons: React.FC<{
  handleBack?: () => void;
}> = ({ handleBack }) => {
  const t = useTranslation();
  return (
    <Box display="flex" gridGap={16}>
      {handleBack && (
        <MopButton
          onClick={handleBack}
          mopVariant="secondary"
          fullWidth
          variant="contained"
        >
          {t("uiBack")}
        </MopButton>
      )}
      <MopButton mopVariant="primary" fullWidth type="submit">
        {t("uiNext")}
      </MopButton>
    </Box>
  );
};
